import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const MobileCarouselStyles = css`
  .mobile-carousel {
    --spacing-xs: 8px;
    --spacing-sm: 16px;
    --spacing-md: 20px;
    --spacing-lg: 24px;
    --arrow-size: 30px;
    --dot-size: 8px;

    width: 100%;
    background-color: transparent;
    position: relative;
  }

  .mobile-carousel__header {
    padding: var(--spacing-md) var(--spacing-sm) var(--spacing-sm);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .mobile-carousel__subheading {
    font-size: 12px;
    font-weight: 400;
    color: ${colors.gray.shade40};
    margin: 4px 0 0 0;
    line-height: 1.3;
  }

  .mobile-carousel__content {
    position: relative;
    width: 100%;
  }

  .mobile-carousel__nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: var(--arrow-size);
    height: var(--arrow-size);
    border-radius: 24px;
    color: ${colors.gray.shade40};
    border: 1px solid ${colors.gray.shade40};
    background-color: ${colors.white.shade1};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .mobile-carousel__nav:hover:not(:disabled) {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-50%) scale(1.02);
  }

  .mobile-carousel__nav:disabled {
    color: ${colors.gray.shade37};
    border: 1px solid ${colors.gray.shade37};
    background-color: ${colors.white.shade1};
    opacity: 0.7;
    cursor: not-allowed;
  }

  .mobile-carousel__nav--prev {
    left: -20px;
  }

  .mobile-carousel__nav--next {
    right: -20px;
  }

  .mobile-carousel__track {
    display: flex;
    align-items: stretch;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 0 var(--spacing-sm) var(--spacing-md) var(--spacing-sm);
    gap: var(--spacing-xs);
  }

  .mobile-carousel__track::-webkit-scrollbar {
    display: none;
  }

  .mobile-carousel__content--mobile .mobile-carousel__track {
    padding-right: var(--spacing-xs);
  }

  .mobile-carousel__content--mobile .mobile-carousel__track > :global(.carousel__pod) {
    flex-shrink: 0;
  }

  .mobile-carousel__content--mobile .mobile-carousel__track > :global(.carousel__pod):last-child {
    margin-right: var(--spacing-sm);
  }

  .mobile-carousel__content--tablet .mobile-carousel__track > :global(.carousel__pod) {
    min-width: calc(25% - 9px);
    max-width: calc(25% - 9px);
    flex-shrink: 0;
  }

  .mobile-carousel__content--desktop .mobile-carousel__track {
    overflow: hidden;
    padding: 0;
    gap: var(--spacing-sm);
    scroll-snap-type: x mandatory;
  }

  .mobile-carousel__content--desktop .mobile-carousel__track > :global(.carousel__pod) {
    min-width: calc((100% - 80px) / 6);
    max-width: calc((100% - 80px) / 6);
    flex: 0 0 auto;
  }

  .mobile-carousel__content--desktop .mobile-carousel__track > :global(.carousel__pod):nth-child(6n + 1) {
    scroll-snap-align: start;
  }

  .mobile-carousel__indicators {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--spacing-xs) var(--spacing-sm) var(--spacing-sm);
    gap: var(--spacing-xs);
  }

  .mobile-carousel__dot {
    width: var(--dot-size);
    height: var(--dot-size);
    border-radius: 50%;
    border: none;
    background-color: ${colors.gray.shade33};
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
    outline: none;
  }

  .mobile-carousel__dot:hover {
    background-color: ${colors.gray.shade40};
  }

  .mobile-carousel__dot--active {
    background-color: ${colors.gray.shade40};
    transform: scale(1.2);
  }

  .mobile-carousel__dot:focus {
    outline: 2px solid ${colors.blue.shade1};
    outline-offset: 2px;
  }

  @media (min-width: 768px) {
    .mobile-carousel__header {
      padding: var(--spacing-md) var(--spacing-lg) var(--spacing-sm) var(--spacing-lg);
    }

    .mobile-carousel__track {
      padding: 0 var(--spacing-lg) var(--spacing-md) var(--spacing-lg);
      gap: var(--spacing-sm);
    }

    .mobile-carousel__indicators {
      padding: 12px var(--spacing-lg) var(--spacing-md) var(--spacing-lg);
    }
  }

  @media (min-width: 1024px) {
    .mobile-carousel__header {
      padding: var(--spacing-lg) 0 var(--spacing-md) 0;
    }

    .mobile-carousel__content--desktop .mobile-carousel__track {
      padding: 0;
    }

    .mobile-carousel__indicators {
      padding: var(--spacing-sm) 0 var(--spacing-lg) 0;
    }
  }
`;

export { MobileCarouselStyles };
